import { Component, Input } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";

export interface BlueprintPreviewItem {
  id: number;
  serviceTreeId: string;
  previewContent: string;
}

@Component({
  standalone: false,
  templateUrl: "./assign-preview-modal.component.html",
  styleUrls: ["./assign-preview-modal.component.scss"],
})
export class CapacityBlueprintAssignPreviewModalComponent {
  @Input() blueprintPreviews: BlueprintPreviewItem[] = [];
  @Input() projectOid: string = "";

  constructor(public activeModal: NgbActiveModal) {}

  onConfirm(): void {
    this.activeModal.close(true);
  }

  onCancel(): void {
    this.activeModal.dismiss(false);
  }
}
